import _ from 'lodash';

import {
  ausTypeFieldName,
  duAusStatusFieldName,
  lpAusStatusFieldName,
  waiverAusStatusFieldName,
} from 'constants/loanApplication';

const buildHeaderViewColumn = (columnItems, columnIndex) => {
  const cellsByRow = _.groupBy(columnItems, item => item.rowIndex ?? 0);
  const sortedRowKeys = _.sortBy(_.keys(cellsByRow), key => Number(key));
  const cells = sortedRowKeys.map(rowKey => ({
    rowIndex: Number(rowKey),
    items: _.sortBy(cellsByRow[rowKey], item => item.position ?? 0),
  }));

  return {
    columnIndex,
    hasDividerAfter: columnItems.some(item => item.hasDividerAfter),
    cells,
  };
};

export const groupLoanHeaderViewItemsByColumn = (headerViewItems, type) => {
  const filtered = (headerViewItems ?? [])
    .filter(item => item.type === type)
    .map(item => ({ ...item, normalizedName: _.toLower(item.name) }));

  const itemsByColumn = _.groupBy(filtered, item => item.columnIndex ?? 0);
  const sortedColumnKeys = _.sortBy(_.keys(itemsByColumn), key => Number(key));

  return sortedColumnKeys.map(columnKey =>
    buildHeaderViewColumn(itemsByColumn[columnKey], Number(columnKey)),
  );
};

export const updateAusRelatedDataInHeaderView = (headerViewitems, newData) =>
  headerViewitems?.map(headerViewItem => {
    const normalizedName = headerViewItem.name.toLowerCase();

    if (normalizedName === lpAusStatusFieldName) {
      headerViewItem.value = newData.lp;
    }

    if (normalizedName === duAusStatusFieldName) {
      headerViewItem.value = newData.du;
    }

    if (normalizedName === waiverAusStatusFieldName) {
      headerViewItem.value = newData.waiver;
    }

    if (normalizedName === ausTypeFieldName) {
      headerViewItem.value = _.toUpper(newData.typeOfAus);
    }

    return headerViewItem;
  });
